import { render, staticRenderFns } from "./SurfacePostComment.vue?vue&type=template&id=bf7b1364&scoped=true&"
import script from "./SurfacePostComment.vue?vue&type=script&lang=ts&"
export * from "./SurfacePostComment.vue?vue&type=script&lang=ts&"
import style0 from "./SurfacePostComment.vue?vue&type=style&index=0&id=bf7b1364&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf7b1364",
  null
  
)

export default component.exports